<h1 mat-dialog-title>Foto do Produto <div style="font-size: smaller; display: inline-block;">(520 x 410)</div></h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: auto; height: 100%;">
    <div class="row mt-2">
        <div class="col-sm">
            <input id="file-input" type="file" (change)="fileChangeEvent($event)" accept="image/x-png,image/jpeg"
                style="width: 700px;" />
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-sm">
            <mat-divider></mat-divider>
        </div>
    </div>

    <div class="row mt-2" *ngIf="imageChangedEvent || imageFile">
        <div class="col-auto" style="background-color: #F0F0F0; border-radius: 5px;">
            <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="false" [cropperMinWidth]="520"
                [imageFile]="imageFile" [cropperMinHeight]="410" [cropperMaxWidth]="520" [cropperMaxHeight]="410"
                [canvasRotation]="canvasRotation" [transform]="transform" [aspectRatio]="4 / 3"
                style="max-width: 400px; max-height: 400px; margin: 4px;" format="png"
                (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
                (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>

        <div class="col-auto ml-4">
            <div style="background-color: #F0F0F0; border-radius: 5px;">
                <img style="max-height: 200px; margin: 4px" [src]="croppedImage" />
            </div>
        </div>
    </div>

    <div *ngIf="imageChangedEvent || imageFile">
        <div class="row mt-2">
            <div class="col-sm">
                <mat-divider></mat-divider>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-auto">
                <h1  class="customH1">Zoom</h1>
                <mat-slider min="0.1" max="2" step="0.1" [(ngModel)]="scale" (input)="onZoom($event)"></mat-slider>
            </div>

            <div class="col-auto">
                <h1  class="customH1">Girar</h1>
                <button mat-stroked-button color="primary" (click)="rotateRight()">
                    <mat-icon>rotate_right</mat-icon>
                </button>

                <button class="ml-2" mat-stroked-button color="primary" (click)="rotateLeft()">
                    <mat-icon>rotate_left</mat-icon>
                </button>
            </div>

            <div class="col-auto">
                <h1  class="customH1">Espelhar</h1>
                <button mat-stroked-button color="primary" (click)="flipHorizontal()">
                    <mat-icon>flip</mat-icon> Horizontal
                </button>

                <button class="ml-2" mat-stroked-button color="primary" (click)="flipVertical()">
                    <mat-icon>flip</mat-icon> Vertical
                </button>
            </div>

            <div class="col-auto">
                <h1  class="customH1">Reiniciar ajustes</h1>
                <button mat-stroked-button color="primary" (click)="resetImage()">
                    <mat-icon>autorenew</mat-icon>
                </button>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm">
                <mat-divider></mat-divider>
            </div>
        </div>
    </div>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="cortar()">
            <mat-icon>save</mat-icon> Salvar corte
        </button>
    </section>

</div>